(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', '../colors'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('../colors'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.colors);
    global.getColorFromProps = mod.exports;
  }
})(this, function (exports, _colors) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = getColorFromProps;

  var _colors2 = _interopRequireDefault(_colors);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function getColorFromProps(_ref) {
    var color = _ref.color;

    return _colors2.default[color] && { color: _colors2.default[color] };
  }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/styles/typography/getColorFromProps.js
// module id = 1852
// module chunks = 1